/**
 * @generated SignedSource<<36f06b3b314cfe0742196911d03e19ea>>
 * @relayHash ca4d64bfb301e4a562078ac57d0e17d9
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ca4d64bfb301e4a562078ac57d0e17d9

import { ConcreteRequest } from 'relay-runtime';
export type de_BetterDocAnamnesisInfoSchemaAttributeAction = "DISCARD" | "TRANSFORM";
export type de_BetterDocAnamnesisInfoSchemaStatus = "ACTIVE" | "FUTURE" | "INACTIVE";
export type de_BetterDocAnamnesisInfoSchemaValueType = "BOOLEAN" | "JSON_ARRAY" | "JSON_OBJECT" | "NUMBER" | "TEXT" | "WHOLE_NUMBER";
export type de_BetterDocRemoteRequestStatus = "INVALID_RECOMMENDATION_ID" | "NOT_FOUND" | "RECEIVED" | "REQUEST_FAILED" | "UNEXPECTED_RESPONSE";
export type betterDocAnamnesisInfoSchemasQuery$variables = Record<PropertyKey, never>;
export type betterDocAnamnesisInfoSchemasQuery$data = {
  readonly de_betterDocAnamnesisInfoSchemas: {
    readonly errorReason: string | null;
    readonly exchangeId: number | null;
    readonly httpStatusCode: number | null;
    readonly schemas: ReadonlyArray<{
      readonly attributes: ReadonlyArray<{
        readonly action: de_BetterDocAnamnesisInfoSchemaAttributeAction | null;
        readonly allowedValuesJson: ReadonlyArray<string>;
        readonly description: string | null;
        readonly isNullable: boolean | null;
        readonly itemDefinitionJson: string | null;
        readonly name: string;
        readonly requirementJson: string | null;
        readonly source: string | null;
        readonly valueType: de_BetterDocAnamnesisInfoSchemaValueType | null;
      }>;
      readonly name: string;
      readonly selector: ReadonlyArray<{
        readonly path: string;
        readonly value: string;
      }>;
      readonly status: de_BetterDocAnamnesisInfoSchemaStatus;
      readonly version: string;
    }>;
    readonly status: de_BetterDocRemoteRequestStatus;
  };
};
export type betterDocAnamnesisInfoSchemasQuery = {
  response: betterDocAnamnesisInfoSchemasQuery$data;
  variables: betterDocAnamnesisInfoSchemasQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "de_BetterDocRemoteAnamnesisInfoSchemasResult",
    "kind": "LinkedField",
    "name": "de_betterDocAnamnesisInfoSchemas",
    "plural": false,
    "selections": [
      (v0/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "httpStatusCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorReason",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "exchangeId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "de_BetterDocRemoteAnamnesisInfoSchema",
        "kind": "LinkedField",
        "name": "schemas",
        "plural": true,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "de_BetterDocRemoteAnamnesisInfoSchemaSelectorEntry",
            "kind": "LinkedField",
            "name": "selector",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "path",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "de_BetterDocRemoteAnamnesisAttributeDefinition",
            "kind": "LinkedField",
            "name": "attributes",
            "plural": true,
            "selections": [
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "valueType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requirementJson",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "action",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "source",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isNullable",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allowedValuesJson",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "itemDefinitionJson",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "betterDocAnamnesisInfoSchemasQuery",
    "selections": (v2/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "betterDocAnamnesisInfoSchemasQuery",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "id": "ca4d64bfb301e4a562078ac57d0e17d9",
    "metadata": {},
    "name": "betterDocAnamnesisInfoSchemasQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "357b31fe8430f6e720c723dc372f8635";

export default node;
